import { render } from "./SolicitudesView.vue?vue&type=template&id=5845cc01&scoped=true"
import script from "./SolicitudesView.vue?vue&type=script&lang=js"
export * from "./SolicitudesView.vue?vue&type=script&lang=js"

import "./SolicitudesView.vue?vue&type=style&index=0&id=5845cc01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845cc01"]])

export default __exports__